import api from './api'
import type { Category, Product, CategoryDTO, ProductDTO } from '@/types'

export const menuService = {
  // ========== Categories ==========
  async getCategories(restaurantId: string): Promise<Category[]> {
    const response = await api.get<Category[]>(`/api/menu/categories?restaurantId=${restaurantId}`)
    return response.data
  },

  async createCategory(restaurantId: string, data: Omit<CategoryDTO, 'id' | 'restaurantId'>): Promise<Category> {
    const response = await api.post<Category>(`/api/menu/categories?restaurantId=${restaurantId}`, data)
    return response.data
  },

  async updateCategory(categoryId: string, data: Partial<CategoryDTO>): Promise<Category> {
    const response = await api.put<Category>(`/api/menu/categories/${categoryId}`, data)
    return response.data
  },

  async deleteCategory(categoryId: string): Promise<void> {
    await api.delete(`/api/menu/categories/${categoryId}`)
  },

  // ========== Products ==========
  async getProducts(restaurantId: string): Promise<Product[]> {
    const response = await api.get<Product[]>(`/api/menu/products?restaurantId=${restaurantId}`)
    return response.data
  },

  async getProductsByCategory(categoryId: string): Promise<Product[]> {
    const response = await api.get<Product[]>(`/api/menu/products/category/${categoryId}`)
    return response.data
  },

  async createProduct(restaurantId: string, data: Omit<ProductDTO, 'id' | 'restaurantId'>): Promise<Product> {
    const response = await api.post<Product>(`/api/menu/products?restaurantId=${restaurantId}`, data)
    return response.data
  },

  async updateProduct(productId: string, data: Partial<ProductDTO>): Promise<Product> {
    const response = await api.put<Product>(`/api/menu/products/${productId}`, data)
    return response.data
  },

  async toggleProductAvailability(productId: string): Promise<Product> {
    const response = await api.patch<Product>(`/api/menu/products/${productId}/availability`)
    return response.data
  },

  async deleteProduct(productId: string): Promise<void> {
    await api.delete(`/api/menu/products/${productId}`)
  },
}
